<template>
    <div class="zhe" v-show="show">
        <div class="tsa-signName" :style="style" ref="tsa-signName" id="tsaSignName">
            <div class="header" ref="header">
                <p @click="goback" style="color:#ccc">关闭</p>
                <!-- <span class="iconfont iconfont icon-31fanhui1" @click="goback"></span> -->
                <h3>添加手写签名</h3>
                <p @click="success" :style="{color: empty ? '#ccc' : '#fff'}">完成</p>
            </div>
            <div class="content">
                <p class="tips" v-show="empty">请书写清晰可辨的签名</p>
                <div class="sign-canvas" id="canvas-container">
                    <canvas class="canvas" id="canvas"></canvas>
                </div>
            </div>
            <div class="footer" ref="footer">
                <div class="penSize">
                    <p>请选择笔画粗细</p>
                    <ul>
                        <li :class="['s' + index, item.selected ? 'selected' : '']" v-for="(item, index) in thickness" :key="index" @click="choose(item)"></li>
                    </ul>
                </div>
                <div class="clear">
                    <a href="javascript:;" @click="clear">清除</a>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import SmoothSignature from 'smooth-signature';
export default {
    name: 'tsa-signName',
    data () {
        return {
            show: false,
            signature: null,
            minWidth:4,
            maxWidth: 10,
            thickness: [
                {
                    minWidth: 4,
                    maxWidth: 10,
                    selected: true
                },
                {
                    minWidth: 8,
                    maxWidth: 16,
                    selected: false
                },
                {
                    minWidth: 10,
                    maxWidth: 20,
                    selected: false
                }
            ],
            empty: true,
            style: {},
            status: 0,
            wdith: 0,
            height: 0,
            type: 'base64',
            value: '',
            clientWidth: 0,
            clientHeight: 0,
            ratio: 0
        }
    },
    watch: {
        show (val) {
            if (val) {
                this.$nextTick(() => {
                    let clientHeight=document.getElementById('tsaSignName').offsetHeight;
                    let clientWidth=document.getElementById('tsaSignName').offsetWidth;
                    this.style = {
                        width: clientWidth + 'px',
                        height: clientHeight + 'px',
                    }
                    this.clientWidth = clientWidth
                    this.clientHeight = clientHeight
                    this.updateUI()
                })
            } else {
                this.signature = null
                this.empty = true
                this.value = ''
            }
        }
    },
    methods: {
        updateUI () {
            const canvas = document.getElementById('canvas');
            let width = 0
            let height = 0
            if (this.width) {
                width = this.width
            } else {
                width = this.clientWidth
            }
            if (this.height) {
                height = this.height
            } else {
                let header = this.$refs.header
                let footer = this.$refs.footer
                height = this.clientHeight - header.offsetHeight - footer.offsetHeight
            }
            this.signature = new SmoothSignature(canvas, {
                scale: 1,
                width: width,
                height: height,
                minWidth: this.minWidth,
                maxWidth: this.maxWidth,
                onStart: () => {
                    this.empty = this.signature.isEmpty()
                },
                onEnd: () => {
                    this.empty = this.signature.isEmpty()
                }
            })
        },
        choose (item) {
            this.thickness.map(item => {
                item.selected = false
            })
            item.selected = true
            let { minWidth, maxWidth } = item
            this.minWidth = minWidth
            this.maxWidth = maxWidth
            this.signature = null
            document.getElementById('canvas-container').removeChild(document.getElementById('canvas'))
            document.getElementById('canvas-container').innerHTML = '<canvas class="canvas" id="canvas" style="cursor: crosshair; background:none;z-index: 999;position: relative"></canvas>'
            this.updateUI()
            this.empty = true
        },
        goback () {
            // this.$router.go(-1)
            this.show = false
        },
        async success () {
            if (this.empty ) return
            let base64 = this.signature.getPNG()
            // let { width, height } = document.getElementById('canvas')
            let img = new Image()
            img.src = base64
            let that = this
            img.onload = async function () {
                //console.log(img.width+'_____'+img.height)
                let canvas = document.createElement('canvas')
                let currentRatio = img.width / img.height > that.ratio // 相当于第一次签名版生成的图片更长
                if (that.ratio) {
                    //console.log(that.ratio)
                    if (currentRatio) {
                        canvas.width = img.width
                        canvas.height = canvas.width / that.ratio
                    } else {
                        canvas.height = img.height
                        canvas.width = canvas.height * that.ratio
                    }
                } else {
                    canvas.width = img.width
                    canvas.height = img.height
                }
                let ctx = canvas.getContext('2d')
                ctx.translate(canvas.width/2,canvas.height/2);
                if (that.ratio) {
                    if (currentRatio) {
                        let dx = (canvas.width - img.width)/2
                        ctx.drawImage(img,-canvas.width/2 + dx,-canvas.height/2);
                    } else {
                        let dy = (canvas.height - img.height)/2
                        ctx.drawImage(img,-canvas.width/2,-canvas.height/2 + dy);
                    }
                } else {
                    ctx.drawImage(img,-canvas.width/2,-canvas.height/2);
                }
                if (that.type === 'base64') {
                    that.value = canvas.toDataURL()
                } else if (that.type === 'blob') {
                    that.value = that.blobToFile(that.dataURLtoBlob(canvas.toDataURL()), new Date().getTime() + '.png')
                }
                that.status++
            }
            
        },
        //将base64转换为blob
        dataURLtoBlob (dataurl) { 
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        //将blob转换为file
        blobToFile (theBlob, fileName) {
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        },
        clear () {
            this.signature.clear()
            this.empty = this.signature.isEmpty()
        }
    }
}
</script>

<style lang="less" scoped>
.zhe{
    top:0;
    left: 0;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    background: rgba(0,0,0,.5);
}
.tsa-signName {
    width:736px;
    height: 414px;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin:auto;
    display: flex;
    flex-direction: column;
    transform-origin: left top;
    background: #fff;
    .header {
        width: 100%;
        height: 54Px;
        flex-shrink: 0;
        background: #10A0E9;
        display: flex;
        align-items: center;
        padding: 0 31.5Px 0 25Px;
        box-sizing: border-box;
        p{
            cursor: pointer;
        }
        .arrowLeft {
            font-size: 15Px;
            color: #fff;
            flex-shrink: 0;
        }
        h3 {
            color: #fff;
            font-size: 15Px;
            flex: 1;
            text-align: center;
        }
        p {
            color: #fff;
            font-size: 15Px;
            flex-shrink: 0;
        }
    }
    .content {
        flex: 1;
        position: relative;
        background: #F0F0F0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .tips {
            user-select:none; 
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 24Px;
            color: #D2D2D2;
        }
        .sign-canvas {
            width: 736px;
            height: calc(414px - 54Px - 54Px);
            transform-origin: left top;
            .canvas {
                cursor: crosshair;
                width: 100%;
                height: 100%;
                background:none;
                z-index: 999;
                position: relative;
            }
        }
    }
    .footer {
        width: 100%;
        height: 54Px;
        flex-shrink: 0;
        display: flex;
        padding: 0 30Px 0 26.5Px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1Px solid #DDDDDD;
        box-sizing: border-box;
        .penSize {
                display: flex;
                align-items: center;
            p {
                color: #666666;
                font-size: 14Px;
                margin-right: 9.5Px;
            }
            ul {
                display: flex;
                .selected {
                    border: 1Px solid #D5D5D5;
                }
                li {
                    cursor: pointer;
                    width: 25Px;
                    height: 25Px;
                    border-radius: 2.5Px;
                    box-sizing: border-box;
                    position: relative;
                    margin-right: 10Px;
                    &::after {
                        content: '';
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        border-radius: 50%;
                        width: 5Px;
                        height: 5Px;
                        background: #000;
                    }
                }
                .s2 {
                    &::after {
                        width: 7Px;
                        height: 7Px;
                    }
                }
                .s3 {
                    &::after {
                        width: 10Px;
                        height: 10Px;
                    }
                }
            }
        }
        .clear {
            overflow:visible;
            a {
                padding: 8.5Px 16.5Px;
                font-size: 14Px;
                color: #00B9ED;
                border: 1Px solid #00B9ED;
            }
        }
    }
}
</style>